module.exports = __webpack_public_path__ + "static/img/R22.47b6f29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productList/oem/R22.jpg
// module id = ZWSj
// module chunks = 1